import request from '../services/request';
import { PATH } from './path';

// sql列表
export const requestSqlList = async params => {
  return request({
    url: PATH.saveSql.getSqlList,
    method: 'get',
    params
  });
};
// 数据表列表
export const requestDelSql = async data => {
  return request({
    url: PATH.saveSql.delSql,
    method: 'post',
    data
  });
};
